import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';

class Formularioformapago extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Forma Pago",
            msg: 0,
            comp: "",
            id_forma_pago: "",
            empresa: currentCompany,
            descripcion: "",
            periodicidad: "",
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: ""
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_forma_pago = "";
        const resolucionEdicion = search.replace('?', '');
        if (resolucionEdicion) {
            titulo = "Modificar Forma Pago";
            id_forma_pago = resolucionEdicion;
            const datasend = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/paymenttype/' + resolucionEdicion, datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        this.setState({
                            //descripcion: datos[0]["CODIGO_EMPRESA"],
                            descripcion: datos[0]["DESCRIPCION_FORMA_PAGO"],
                            periodicidad: datos[0]["PERIODICIDAD"]
                        });
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: data.message })
                    }
                });
        } else {
            titulo = "Crear Forma Pago";
            id_forma_pago = "";
        }
        this.setState({ id_forma_pago , titulo });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        const { empresa } = this.state
        const { descripcion } = this.state
        const { periodicidad } = this.state

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa: empresa,
                descripcion: descripcion,
                periodicidad: periodicidad
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_forma_pago === "") {
            ruta = config.servBackEnd + '/paymenttype/create';
        } else {
            ruta = config.servBackEnd + '/paymenttype/modify/' + this.state.id_forma_pago;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevaFormaPago = (data.data.insertId!==0)? data.data.insertId : this.state.id_forma_pago ;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_forma_pago : nuevaFormaPago })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Forma Pago con errores:" + errores[data.code] +" " + data.message })
                }
            });
        event.preventDefault();
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const mensajeBoton = (this.state.id_forma_pago === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_forma_pago === "") ? '¿Esta seguro que desea crear la forma de pago?' : '¿Esta seguro que desea modificar la forma de pago?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        return (
            <div className="Formularioformapago">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Forma Pagoes!</Tooltip>}>
                            <div className="div-back">
                                <a href="/formapago/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Forma Pago</Form.Label>
                                            <Form.Control type="text" placeholder="Forma Pago" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                        </Form.Group>


                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Periodicidad</Form.Label>
                                            <Form.Control type="number" placeholder="0" onChange={e => this.setState({ periodicidad: e.target.value })} value={this.state.periodicidad} required />
                                        </Form.Group>
                                    </Form.Row>

                                    <Button  variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioformapago);